import { Component, Input, OnInit } from '@angular/core';
import { QueryRecord } from '../../../../API';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-list-query-result',
  templateUrl: './list-query-result.component.html',
  styleUrl: './list-query-result.component.scss',
})
export class ListQueryResultComponent implements OnInit {
  @Input() queryRecord!: QueryRecord;
  metaData: any = {};

  constructor(private nzMessageService: NzMessageService) {}

  ngOnInit(): void {
    this.prepareMetaData();
  }

  prepareMetaData(): void {
    try {
      this.metaData = JSON.parse(this.queryRecord.metadata!);
      this.metaData.attributes = this.metaData.columnsList?.map((column: any) => column.label)?.join(', ');
    } catch (error: any) {
      this.nzMessageService.error('Failed to fetch result. ' + error?.message);
    }
  }
}
